export enum ASSET_IMAGE_TYPE {
  BANNER = 'banner',
  LOGO_COMPANY = 'logo_company',
  BANNER_COMPANY = 'banner_company',
}
